import Api from './api.service';

const ENDPOINT = 'dashboard';

export default {
  getScheduleListValues(params = {}) {
    return Api.get(`${ENDPOINT}/schedule-list-value`, { params });
  },

  getSchedulesInfo(params = {}) {
    return Api.get(`${ENDPOINT}/schedules`, { params });
  },

  getPatientsTableInfo(params = {}) {
    return Api.get(`${ENDPOINT}/clients-table-info`, { params });
  },
  getPatientsChartsInfo(params = {}) {
    return Api.get(`${ENDPOINT}/clients-charts-info`, { params });
  },
};
